// extracted by mini-css-extract-plugin
export default {"wrapper":"ListsResultSearch_wrapper__I6Wd2","list":"ListsResultSearch_list__Ln9qC"};